import { render, staticRenderFns } from "./VTableHead.vue?vue&type=template&id=28641602&"
import script from "./VTableHead.vue?vue&type=script&lang=js&"
export * from "./VTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports